import React from "react";
import "./Header.scss";
import { AppIcons } from "../../../data/appIcons";
import Iconify from "../../../components/ui/iconify/Iconify";
import Image from "../../../components/image/Image";
import SidebarModal from "../../../components/ui/sidebarmodal/SidebarModal";
import { Link, useNavigate } from "react-router-dom";
import { DropdownWrapper } from "../../../components/ui/dropdownwrapper/DropdownWrapper";
import Avatar from "../../../components/ui/avatar/Avatar";
import { getAuthProps } from "../../../lib/authenticationLibrary";
import { useDispatch } from "react-redux";
import { logout } from "../../../app/slice/authSlice";

const Header = () => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = React.useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const dispatch = useDispatch();
  const authData = getAuthProps();


  const handleLogout = () => {
    dispatch(logout())
  };

  const handleChangePassword = () => {
    navigate("/changePassword");
  }

  return (
    <div className="header-container">
      <div className="left-section">
        <div className="welcome-text">
          Welcome, <span>{authData?.user?.userName}</span>
        </div>
      </div>
      <div className="middle-section">
        <Image
          imgCustomClassName="bnb-logo"
          imagePath={AppIcons.BnBLogo}
          altText="Arrow Icon"
        />
      </div>
      <div className="right-section">
        <DropdownWrapper
          toggleElement={
            <div className="user-info-icon">
              <Avatar
                alt="Admin"
                size="small"
                shape="circle"
                icon="el:user"
                width={17}
              />
            </div>
          }
        >
          {/* <button className="header-icon logout" onClick={handleLogout}>
          <Iconify icon="ri:logout-circle-r-line" />
        </button> */}
          <div className="user-info">
            <div className="user-top-section">
              <div className="user-left">
                <Avatar
                alt="userName"
                size="small"
                shape="circle"
              />
              </div>
              <div className="user-right">
                <div className="user-name">{authData?.user?.userName}</div>
                <div className="user-role">Admin</div>
              </div>
            </div>
            <div className="user-middle-section">
              <button className="user-middle-section-button" onClick={handleChangePassword}>
                <Iconify icon="mdi:password-outline" width={15} />
                Change Password
              </button>
            </div>
            <div className="user-bottom-section">
              <button className="logout-button" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </DropdownWrapper>
      </div>

      <SidebarModal
        isOpen={modalOpen}
        onClose={closeModal}
        modalTitle="Basic Sidebar Modal"
      >
        <p>This is a simple sidebar modal.</p>
      </SidebarModal>
    </div>
  );
};

export default Header;
